export const AutocompleteConstants = {
    AUTOCOMPLETE_OPERATION_FAILED: 'AUTOCOMPLETE_OPERATION_FAILED',
    GET_UNITS: 'AUTOCOMPLETE_GET_UNITS',
    GET_UNITS_SUCCESS: 'AUTOCOMPLETE_GET_UNITS_SUCCESS',
    GET_SCHOOLS: 'AUTOCOMPLETE_GET_SCHOOLS',
    GET_SCHOOLS_SUCCESS: 'AUTOCOMPLETE_GET_SCHOOLS_SUCCESS',
};